function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import GoogleReCaptcha from "@common/components/GoogleReCaptcha";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import React, { Component } from "react";
import { connect } from "react-redux";
import html2canvas from "html2canvas";
import { DISABLE_WRITE_TO_US, EMAIL, FILE_UPLOAD_MAX_SIZE, KEY_ENTER, KEY_ESCAPE, KEY_SPACE, MESSAGE, SUBJECT } from "@config/constants";
import Spinner from "@common/components/Spinner";
import { validateEmail } from "@common/services/helpers";
import request from "@common/services/request";
import { closeModal, closeWriteToUs, openModal } from "@common/actions";
var SUBJECT_MAX_LENGTH = 120;
var MESSAGE_MAX_LENGTH = 250;
export var WriteToUs = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(WriteToUs, Component);
    var _super = _create_super(WriteToUs);
    function WriteToUs(props) {
        _class_call_check(this, WriteToUs);
        var _this;
        _this = _super.call(this, props);
        _this.onChange = _this.onChange.bind(_assert_this_initialized(_this));
        _this.sendMessage = _this.sendMessage.bind(_assert_this_initialized(_this));
        _this.changeEmail = _this.changeEmail.bind(_assert_this_initialized(_this));
        _this.handleFileUpload = _this.handleFileUpload.bind(_assert_this_initialized(_this));
        _this.removeFile = _this.removeFile.bind(_assert_this_initialized(_this));
        _this.removeScreenshot = _this.removeScreenshot.bind(_assert_this_initialized(_this));
        _this.getScreenshot = _this.getScreenshot.bind(_assert_this_initialized(_this));
        _this.handleClickOutside = _this.handleClickOutside.bind(_assert_this_initialized(_this));
        _this.setWrapperRef = _this.setWrapperRef.bind(_assert_this_initialized(_this));
        _this.toggleRecapcha = _this.toggleRecapcha.bind(_assert_this_initialized(_this));
        _this.handleFileUploadFromKeyboard = _this.handleFileUploadFromKeyboard.bind(_assert_this_initialized(_this));
        _this.removeFileFromKeyboard = _this.removeFileFromKeyboard.bind(_assert_this_initialized(_this));
        _this.removeScreenshotFromKeyboard = _this.removeScreenshotFromKeyboard.bind(_assert_this_initialized(_this));
        _this.closeFromKeyboard = _this.closeFromKeyboard.bind(_assert_this_initialized(_this));
        _this.validateInput = _this.validateInput.bind(_assert_this_initialized(_this));
        _this.renderMessageInputs = _this.renderMessageInputs.bind(_assert_this_initialized(_this));
        _this.renderChangeEmailInput = _this.renderChangeEmailInput.bind(_assert_this_initialized(_this));
        _this.fileUploadInput = null;
        _this.focusTimeout = null;
        _this.state = {
            subject: "",
            subjectError: "",
            message: "",
            messageError: "",
            serverError: "",
            showChangeEmailInput: false,
            email: "",
            emailError: "",
            file: null,
            hasScreenshot: false,
            uploadingPending: false,
            screenshot: null,
            isMessageSent: false,
            isFileTooBig: false,
            isRecaptchaChecked: false,
            recaptchaToken: null,
            isMessageBeingSent: false,
            screnshotData: null
        };
        return _this;
    }
    _create_class(WriteToUs, [
        {
            /**
     * Open the change email input from which the message is sent
     */ key: "changeEmail",
            value: function changeEmail() {
                this.setState({
                    showChangeEmailInput: true
                });
            }
        },
        {
            /**
     * Close modal on escape keydown
     * @param {Object} event
     */ key: "closeFromKeyboard",
            value: function closeFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_ESCAPE) {
                    event.stopPropagation();
                    this.props.closeWriteToUs();
                }
            }
        },
        {
            /**
     * Method which stores the uploaded files in the state
     * @param {Object} event
     */ key: "handleFileUpload",
            value: function handleFileUpload(event) {
                var file = event.target.files[0];
                if (file.size > FILE_UPLOAD_MAX_SIZE) {
                    this.setState({
                        isFileTooBig: true
                    });
                } else {
                    this.setState({
                        file: file,
                        isFileTooBig: false
                    });
                }
            }
        },
        {
            /**
     * Initiate file upload on enter/space keydown on file input
     * @param {Object} event
     */ key: "handleFileUploadFromKeyboard",
            value: function handleFileUploadFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_ENTER || key === KEY_SPACE) {
                    this.fileUploadInput.click();
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                document.addEventListener("mousedown", this.handleClickOutside);
                this.focusTimeout = setTimeout(function() {
                    _this.wrapperRef.focus();
                }, 0);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("mousedown", this.handleClickOutside);
                clearTimeout(this.focusTimeout);
            }
        },
        {
            /**
     * Closes the modal on click outside of the modal wrapper
     * @param {Object} event
     */ key: "handleClickOutside",
            value: function handleClickOutside(event) {
                if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
                    this.props.closeWriteToUs();
                }
            }
        },
        {
            /**
     * Toggles the recaptcha checked value in the state
     * and sets the response token in the state
     * @param {String} value
     */ key: "toggleRecapcha",
            value: function toggleRecapcha(value) {
                var state = {
                    isRecaptchaChecked: !!value,
                    recaptchaToken: value
                };
                this.setState(_object_spread({}, state));
            }
        },
        {
            /**
     * Sets ref on the modal wrapper
     * @param {Object} node
     */ key: "setWrapperRef",
            value: function setWrapperRef(node) {
                this.wrapperRef = node;
            }
        },
        {
            /**
     * Method responsible for making a browser window screenshot
     * uses the html2Canvas library (makes a clone of the DOM and renders it on a canvas element)
     *  @param {Object} event
     */ key: "getScreenshot",
            value: function getScreenshot(event) {
                var _this = this;
                this.setState({
                    hasScreenshot: true,
                    uploadingPending: true
                });
                if (event.target.checked) {
                    html2canvas(document.body, {
                        width: document.documentElement.clientWidth,
                        height: document.documentElement.clientHeight,
                        useCORS: true,
                        logging: false,
                        onclone: function(documentClone) {
                            var video = document.getElementsByTagName("video")[0];
                            var svgElements = documentClone.getElementsByTagName("svg");
                            var sliders = documentClone.querySelectorAll(".slick-slider:not(.category-slider)");
                            var headerLogo = documentClone.getElementsByClassName("logo-header")[0];
                            if (headerLogo) {
                                headerLogo.style.visibility = "hidden";
                            }
                            var accountWrapper = documentClone.getElementsByClassName("account-wrapper")[0];
                            if (accountWrapper) {
                                accountWrapper.style.transform = "none";
                                accountWrapper.style.top = "initial";
                                accountWrapper.style.position = "relative";
                            }
                            // there is a bug with position: absolute and html2canvas
                            var orderWrapper = documentClone.getElementsByClassName("order-wrapper")[0];
                            if (orderWrapper) {
                                var orderWrapperFooters = orderWrapper.getElementsByTagName("footer");
                                if (orderWrapperFooters) {
                                    Array.prototype.forEach.call(orderWrapperFooters, function(footer) {
                                        footer.style.position = "relative";
                                    });
                                }
                            }
                            // html2canvas doesnt support the transition prop
                            var buttons = documentClone.getElementsByClassName("button")[0];
                            if (buttons) {
                                Array.prototype.forEach.call(buttons, function(button) {
                                    button.style.transition = "none";
                                });
                            }
                            var showTitles = documentClone.getElementsByClassName("show-title");
                            // Html2Canvas doesnt support the display: -webkit-box property so in webkit the title are not rendered.
                            // That is why we are setting the title to inline-block in the document clone to make it visible
                            Array.prototype.forEach.call(showTitles, function(showTitle) {
                                showTitle.style.display = "inline-block";
                            });
                            if (svgElements.length > 0) {
                                Array.prototype.forEach.call(svgElements, function(svgElement) {
                                    if (!svgElement) return;
                                    var viewBox = svgElement.getAttribute("viewBox");
                                    // Regex for capturing any word character from the svg viewBox attr. the second part of the regex creates the 2 capturing
                                    // groups for the match
                                    var REGEX = /\w+ \w+ (\w+) (\w+)/;
                                    if (viewBox) {
                                        // here we are extracting the values for width and height from the viewBox attr of the svgElement
                                        // and we are setting them as inline width and height. Otherwise if there are no width or height attr100
                                        // the browser sets them as 0
                                        var match = viewBox.match(REGEX);
                                        var viewBoxWidth = match[1];
                                        var viewBoxHeight = match[2];
                                        svgElement.setAttribute("width", viewBoxWidth);
                                        svgElement.setAttribute("height", viewBoxHeight);
                                    }
                                });
                            }
                            // Html2Canvas doesn't support the transform property thus not visualizing the sliders correctly.
                            // We remove the transform prop from the slider in documentClone and move the slides according to the
                            // slide width and the slide that is selected
                            if (sliders) {
                                Array.prototype.forEach.call(sliders, function(slider) {
                                    var sliderTrack = slider.getElementsByClassName("slick-track")[0];
                                    var slides = sliderTrack.getElementsByClassName("slick-slide");
                                    var slideWidth = null;
                                    var slideActiveIndex = null;
                                    Array.prototype.forEach.call(slides, function(slide, index) {
                                        if (slide.classList.contains("slick-active")) {
                                            slideActiveIndex = index;
                                            slideWidth = slide.offsetWidth;
                                        }
                                    });
                                    sliderTrack.style.transform = "none";
                                    sliderTrack.style.position = "relative";
                                    sliderTrack.style.right = "".concat(slideActiveIndex * slideWidth, "px");
                                });
                            }
                            // because the library cant capture video elements out of the box
                            // we are drawing the video element on a separate canvas
                            // Then we extract the dataURL from the canvas and convert to an image which
                            // we attach to the documentClone before it is rendered by html2canvas
                            if (video) {
                                var videoCanvas = document.createElement("canvas");
                                videoCanvas.width = video.videoWidth;
                                videoCanvas.height = video.videoHeight;
                                var ctx = videoCanvas.getContext("2d");
                                ctx.drawImage(video, 0, 0);
                                var videoImage = videoCanvas.toDataURL("image/png");
                                var videoImageElement = document.createElement("img");
                                videoImageElement.src = videoImage;
                                videoImageElement.className = "video";
                                documentClone.getElementById("video-no-controls-wrapper").prepend(videoImageElement);
                            }
                        }
                    }).then(function(canvas) {
                        var imgUrl = canvas.toDataURL("image/jpeg");
                        var screenshot = /*#__PURE__*/ _jsx("img", {
                            src: imgUrl,
                            id: "screenshot"
                        });
                        _this.setState({
                            screenshot: screenshot,
                            uploadingPending: false,
                            screenshotData: imgUrl
                        });
                    });
                } else {
                    this.removeScreenshot();
                }
            }
        },
        {
            /**
     * Remove the screenshot
     */ key: "removeScreenshot",
            value: function removeScreenshot() {
                this.setState({
                    screenshot: null,
                    hasScreenshot: false
                });
            }
        },
        {
            /**
     * Remove the screenshot on enter/space keydown on X icon
     * @param event {Object}
     */ key: "removeScreenshotFromKeyboard",
            value: function removeScreenshotFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_SPACE || key === KEY_ENTER) {
                    this.removeScreenshot();
                }
            }
        },
        {
            key: "sendMessage",
            value: /**
     * Handle the form submission
     *  @param {Object} event
     */ function sendMessage(event) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_state, subject, message, email, showChangeEmailInput, file, emailError, isRecaptchaChecked, recaptchaToken, screenshotData, userDetails, i18n, isMessageEmpty, isSubjectEmpty, isEmailEmpty, formData, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_state = _this.state, subject = _this_state.subject, message = _this_state.message, email = _this_state.email, showChangeEmailInput = _this_state.showChangeEmailInput, file = _this_state.file, emailError = _this_state.emailError, isRecaptchaChecked = _this_state.isRecaptchaChecked, recaptchaToken = _this_state.recaptchaToken, screenshotData = _this_state.screenshotData;
                                userDetails = _this.props.userDetails;
                                i18n = _this.props.i18n;
                                isMessageEmpty = message === "";
                                isSubjectEmpty = subject === "";
                                isEmailEmpty = email === "" && (showChangeEmailInput || !userDetails.email);
                                if (isMessageEmpty) {
                                    _this.setState({
                                        messageError: i18n.common.addMessage
                                    });
                                }
                                if (isSubjectEmpty) {
                                    _this.setState({
                                        subjectError: i18n.common.addSubject
                                    });
                                }
                                if (isEmailEmpty && !emailError) {
                                    _this.setState({
                                        emailError: i18n.authentication.enterValidMail
                                    });
                                }
                                if (!(isEmailEmpty || isSubjectEmpty || isMessageEmpty || !isRecaptchaChecked)) return [
                                    3,
                                    1
                                ];
                                return [
                                    2
                                ];
                            case 1:
                                formData = new FormData();
                                formData.append("from", email || _this.props.userDetails.email);
                                formData.append("subject", subject);
                                formData.append("content", message);
                                formData.append("upfile", file || screenshotData);
                                formData.append("g-recaptcha-response", recaptchaToken);
                                _this.setState({
                                    isMessageBeingSent: true
                                });
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    request({
                                        method: "POST",
                                        url: "users/contact",
                                        data: formData
                                    })
                                ];
                            case 3:
                                _state.sent();
                                _this.setState({
                                    isMessageSent: true,
                                    isMessageBeingSent: false
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                _this.setState({
                                    isMessageSent: false,
                                    isMessageBeingSent: false
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * render the changeEmailInput
     * returns  {*}
     */ key: "renderChangeEmailInput",
            value: function renderChangeEmailInput() {
                var _this = this;
                var _this_state = this.state, email = _this_state.email, emailError = _this_state.emailError;
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsx(TextField, {
                    className: "ux-text-field-root email-input",
                    autoComplete: "off",
                    InputProps: {
                        onBlur: function() {
                            return _this.validateInput(EMAIL);
                        },
                        className: "ux-input",
                        classes: {
                            error: "ux-input-error"
                        }
                    },
                    InputLabelProps: {
                        classes: {
                            root: "ux-input-label"
                        }
                    },
                    FormHelperTextProps: {
                        error: true,
                        classes: {
                            root: "ux-form-helper-text"
                        }
                    },
                    error: emailError !== "",
                    helperText: emailError,
                    id: EMAIL,
                    type: "text",
                    name: EMAIL,
                    value: email,
                    label: i18n.authentication.email + ":",
                    onChange: this.onChange,
                    margin: "none"
                });
            }
        },
        {
            /**
     * remove file from the files array
     * @param index {number}
     */ key: "removeFile",
            value: function removeFile(index) {
                this.setState({
                    file: null
                });
            }
        },
        {
            /**
     * remove file on enter/space kjeydown on X icon
     * @param event {Object}
     * @param index {Number}
     */ key: "removeFileFromKeyboard",
            value: function removeFileFromKeyboard(event, index) {
                var key = event.which;
                if (key === KEY_SPACE || key === KEY_ENTER) {
                    event.stopPropagation();
                    this.removeFile(index);
                }
            }
        },
        {
            /**
     * render the inputs
     * returns  {*}
     */ key: "renderMessageInputs",
            value: function renderMessageInputs() {
                var _this = this;
                var _this_state = this.state, subject = _this_state.subject, subjectError = _this_state.subjectError, message = _this_state.message, messageError = _this_state.messageError;
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "subject-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx(TextField, {
                                    className: "ux-text-field-root subject-input",
                                    autoComplete: "off",
                                    InputProps: {
                                        onBlur: function() {
                                            return _this.validateInput(SUBJECT);
                                        },
                                        className: "ux-input",
                                        classes: {
                                            error: "ux-input-error"
                                        },
                                        inputProps: {
                                            maxLength: SUBJECT_MAX_LENGTH
                                        }
                                    },
                                    InputLabelProps: {
                                        classes: {
                                            root: "ux-input-label"
                                        }
                                    },
                                    FormHelperTextProps: {
                                        error: true,
                                        classes: {
                                            root: "ux-form-helper-text"
                                        }
                                    },
                                    error: subjectError !== "",
                                    helperText: subjectError,
                                    id: SUBJECT,
                                    type: "text",
                                    name: SUBJECT,
                                    value: subject,
                                    label: i18n.common.subject + ":",
                                    onChange: this.onChange,
                                    margin: "none"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    children: "".concat(subject.length, "/").concat(SUBJECT_MAX_LENGTH)
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "message-wrapper",
                            children: [
                                /*#__PURE__*/ _jsxs("label", {
                                    className: "ux-input-label",
                                    htmlFor: "message",
                                    children: [
                                        i18n.common.message,
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(TextField, {
                                    className: "ux-text-field-root message-input",
                                    autoComplete: "off",
                                    InputProps: {
                                        onBlur: function() {
                                            return _this.validateInput(MESSAGE);
                                        },
                                        className: "ux-input message",
                                        multiline: true,
                                        rows: 10,
                                        classes: {
                                            error: "ux-input-error"
                                        },
                                        inputProps: {
                                            maxLength: MESSAGE_MAX_LENGTH
                                        }
                                    },
                                    FormHelperTextProps: {
                                        error: true,
                                        classes: {
                                            root: "ux-form-helper-text"
                                        }
                                    },
                                    error: messageError !== "",
                                    helperText: messageError,
                                    id: MESSAGE,
                                    type: "text",
                                    name: MESSAGE,
                                    value: message,
                                    onChange: this.onChange,
                                    margin: "none"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    children: "".concat(message.length, "/").concat(MESSAGE_MAX_LENGTH)
                                })
                            ]
                        })
                    ]
                });
            }
        },
        {
            /**
     * Sets the new state for a given input.
     * @param {Object} event
     */ key: "onChange",
            value: function onChange(event) {
                var _this = this;
                var _event_target = event.target, checked = _event_target.checked, name = _event_target.name, type = _event_target.type, value = _event_target.value;
                var isCheckbox = type === "checkbox";
                var key = isCheckbox ? value : name;
                var newValue = isCheckbox ? checked : value;
                this.setState(_define_property({}, key, newValue), function() {
                    return _this.validateInput(key);
                });
            }
        },
        {
            /**
     * Validates the inputs
     * @param name {string}
     */ key: "validateInput",
            value: function validateInput(name) {
                var _this = this;
                var value = this.state[name];
                var error = "";
                if (value.length === 0) {
                    if (name === SUBJECT) {
                        error = this.props.i18n.common.addSubject;
                    }
                    if (name === MESSAGE) {
                        error = this.props.i18n.common.addMessage;
                    }
                }
                if (name === EMAIL) {
                    validateEmail(value, function(isValid) {
                        error = isValid ? "" : _this.props.i18n.authentication.enterValidMail;
                    });
                }
                this.setState(function() {
                    return _define_property({}, "".concat(name, "Error"), error);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_state = this.state, file = _this_state.file, isMessageSent = _this_state.isMessageSent, showChangeEmailInput = _this_state.showChangeEmailInput, hasScreenshot = _this_state.hasScreenshot, uploadingPending = _this_state.uploadingPending, screenshot = _this_state.screenshot, isFileTooBig = _this_state.isFileTooBig, isMessageBeingSent = _this_state.isMessageBeingSent, recaptchaToken = _this_state.recaptchaToken;
                var _this_props = this.props, i18n = _this_props.i18n, userDetails = _this_props.userDetails, _$closeWriteToUs = _this_props.closeWriteToUs;
                var email = userDetails.email;
                var uploadingFinished = !uploadingPending;
                var changeEmailButtonClass = showChangeEmailInput ? " opened-email" : "";
                var fileName = /*#__PURE__*/ _jsx(_Fragment, {
                    children: file ? /*#__PURE__*/ _jsxs("div", {
                        className: "file-wrapper",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "file-name",
                                children: file.name
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "icon icon-clear remove pointer",
                                onClick: this.removeFile
                            })
                        ]
                    }) : null
                });
                return /*#__PURE__*/ _jsx("div", {
                    className: "modal-overlay write-to-us-overlay",
                    "data-html2canvas-ignore": true,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "modal write-to-us-wrapper",
                        onKeyDown: this.closeFromKeyboard,
                        tabIndex: "0",
                        ref: this.setWrapperRef,
                        children: [
                            !DISABLE_WRITE_TO_US && /*#__PURE__*/ _jsxs("div", {
                                className: "modal-header",
                                children: [
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "modal-title",
                                        children: i18n.common.mailUs
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        onClick: _$closeWriteToUs,
                                        className: "icon icon-clear pointer"
                                    })
                                ]
                            }),
                            !isMessageSent ? /*#__PURE__*/ _jsxs("div", {
                                className: "modal-content",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "change-mail-wrapper",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "center-vertical current-mail float-left",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("p", {
                                                        children: [
                                                            userDetails.firstname,
                                                            " ",
                                                            userDetails.lastname,
                                                            " "
                                                        ]
                                                    }),
                                                    !showChangeEmailInput ? /*#__PURE__*/ _jsx("p", {
                                                        className: "email",
                                                        children: userDetails.email
                                                    }) : null,
                                                    !userDetails.email || showChangeEmailInput ? this.renderChangeEmailInput() : null
                                                ]
                                            }),
                                            !showChangeEmailInput && email ? /*#__PURE__*/ _jsx(Button, {
                                                classes: {
                                                    label: "ux-button-label"
                                                },
                                                color: "primary",
                                                onClick: this.changeEmail,
                                                className: "button-no-background change-mail center-vertical raised half-width float-right pointer".concat(changeEmailButtonClass),
                                                children: i18n.common.changeEmail
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "write-to-us-form",
                                        children: [
                                            this.renderMessageInputs(),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "file-upload-wrapper",
                                                children: [
                                                    /*#__PURE__*/ _jsx("input", {
                                                        type: "file",
                                                        name: "file",
                                                        id: "file",
                                                        className: "file-upload pointer",
                                                        accept: ".jpg, .png",
                                                        disabled: file || hasScreenshot ? true : false,
                                                        onChange: this.handleFileUpload
                                                    }),
                                                    /*#__PURE__*/ _jsxs("label", {
                                                        htmlFor: "file",
                                                        className: "blue-text pointer".concat(file || hasScreenshot ? " disabled" : ""),
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "icon icon-attach"
                                                            }),
                                                            i18n.common.attachFile
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "file-type",
                                                        children: "JPG"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "file-type",
                                                        children: "PNG"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "file-size",
                                                        children: "MAX: 5MB"
                                                    }),
                                                    isFileTooBig ? /*#__PURE__*/ _jsx("p", {
                                                        className: "error file-too-big",
                                                        children: i18n.common.fileTooBig
                                                    }) : null,
                                                    file ? /*#__PURE__*/ _jsx("div", {
                                                        className: "file-names-wrapper",
                                                        children: fileName
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "checkbox-wrapper",
                                                children: /*#__PURE__*/ _jsx(FormControlLabel, {
                                                    control: /*#__PURE__*/ _jsx(Checkbox, {
                                                        classes: {
                                                            checked: "ux-checked take-screenshot-checkbox"
                                                        },
                                                        checked: hasScreenshot,
                                                        type: "checkbox",
                                                        onChange: this.getScreenshot
                                                    }),
                                                    disabled: file ? true : false,
                                                    label: i18n.common.takeScreenshot,
                                                    classes: {
                                                        root: "ux-checkbox-label-root screenshot-checkbox".concat(file ? " disabled" : ""),
                                                        label: "ux-checkbox-label tiny-font"
                                                    }
                                                })
                                            }),
                                            hasScreenshot ? /*#__PURE__*/ _jsxs("div", {
                                                className: "screenshot-wrapper",
                                                children: [
                                                    uploadingFinished ? /*#__PURE__*/ _jsx("span", {
                                                        className: "icon icon-clear remove pointer",
                                                        onClick: this.removeScreenshot
                                                    }) : null,
                                                    uploadingPending ? /*#__PURE__*/ _jsx("div", {
                                                        className: "screenshot-wrapper",
                                                        children: /*#__PURE__*/ _jsx(Spinner, {})
                                                    }) : null,
                                                    screenshot
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(GoogleReCaptcha, {
                                        action: "write_to_us",
                                        className: "g-recaptcha".concat(file ? " file-attached" : ""),
                                        onChange: this.toggleRecapcha,
                                        children: !recaptchaToken && /*#__PURE__*/ _jsx("span", {
                                            className: "error",
                                            children: i18n.common.notARobot
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "footer-buttons-wrapper",
                                        children: [
                                            /*#__PURE__*/ _jsx(Button, {
                                                classes: {
                                                    label: "ux-button-label"
                                                },
                                                color: "primary",
                                                onClick: _$closeWriteToUs,
                                                className: "button pointer close-modal",
                                                children: i18n.common.close
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                classes: {
                                                    label: "ux-button-label"
                                                },
                                                className: "button raised send-form-button",
                                                onClick: this.sendMessage,
                                                children: isMessageBeingSent ? /*#__PURE__*/ _jsx(Spinner, {}) : i18n.common.send
                                            })
                                        ]
                                    })
                                ]
                            }) : null,
                            isMessageSent ? /*#__PURE__*/ _jsxs("div", {
                                className: "message-sent-wrapper",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "message-sent-image"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "success-message",
                                        children: i18n.common.messageSent
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        classes: {
                                            label: "ux-button-label"
                                        },
                                        onClick: _$closeWriteToUs,
                                        className: "button raised full-width",
                                        children: i18n.common.ok
                                    })
                                ]
                            }) : null
                        ]
                    })
                });
            }
        }
    ]);
    return WriteToUs;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, authentication = param.authentication, userDetails = param.userDetails, modal = param.modal;
    return {
        i18n: i18n,
        authentication: authentication,
        userDetails: userDetails,
        modal: modal
    };
};
export default connect(mapStateToProps, {
    closeModal: closeModal,
    openModal: openModal,
    closeWriteToUs: closeWriteToUs
})(WriteToUs);
